// window._ = require("lodash");
// window.Popper = require("popper.js").default;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// try {
//   window.$ = window.jQuery = require("jquery");
// } catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.put["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.patch["Content-Type"] =
  "application/x-www-form-urlencoded";

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

// let token = document.head.querySelector('meta[name="csrf-token"]');

// if (token) {
//     window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
// } else {
//     console.error(
//         "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
//     );
// }

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

// Add a request interceptor
// axios.interceptors.request.use(function(config) {
//   // assume your access token is stored in local storage
//   // (it should really be somewhere more secure but I digress for simplicity)
//   let token = localStorage.getItem("jwt");
//   if (token) {
//     config.headers["Authorization"] = `Bearer ${token}`;
//   }
//   return config;
// });
// Add a response interceptor
// axios.interceptors.response.use(
//   function(response) {
//     // Do something with response data

//     return response;
//   },
//   function(error) {
//     // Automatically try to relogin with refresh token
//     if (error.response.status == 401 && localStorage.getItem("jwtrefresh")) {
//       console.warn("AccessToken expired trying to generate new one.");
//       var token = localStorage.getItem("jwtrefresh");
//       axios
//         .post("/oauth/token", {
//           grant_type: "refresh_token",
//           refresh_token: token,
//           client_id: "2",
//           client_secret: this.$APPSECRET
//         })
//         .then(response => {
//           localStorage.setItem("jwtrefresh", response.data.refresh_token);
//           localStorage.setItem("jwt", response.data.access_token);
//           localStorage.setItem("jwtexpires", response.data.expires_in);
//           if (localStorage.getItem("jwt") != null) {
//             this.$forceUpdate();
//           }
//         })
//         .catch(function(error) {
//           window.location.href = "/";
//         });
//     }
//     return error;
//   }
// );